export const timeOptionSportsTrigger = [
  {
    label: "5 Mins",
    value: "300",
  },
  {
    label: "15 Mins",
    value: "900",
  },
  {
    label: "30 Mins",
    value: "1800",
  },
  {
    label: "1 Hrs",
    value: "3600",
  },
  {
    label: "2 Hrs",
    value: "7200",
  },
  {
    label: "3 Hrs",
    value: "10800",
  },
  {
    label: "4 Hrs",
    value: "14400",
  },
];

export const weatherTabData = [
  {
    icon: <i className="fi fi-tr-summer flex items-center"></i>,
    label: "Temperature",
    value: "temperature",
    id: "1",
  },
  {
    icon: <i className="fi fi-ts-cloud-sun-rain flex items-center"></i>,
    label: "Rain",
    value: "rain",
    id: "2",
  },
  {
    icon: <i className="fi fi-ts-pollution flex items-center"></i>,
    label: "AQI",
    value: "aqi",
    id: "3",
  },
];
